function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Service from '@ember/service';
import Kuromoji from 'kuromoji/build/kuromoji';
import { isEmpty } from '@ember/utils';
const kuromojiDictPath = 'https://dashboard-production-f.squarecdn.com/dashboard/uploads/kuromoji/dict/';
export default class ItemFuriganaService extends Service {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "kuromojiTokenizer", null);
  }
  load() {
    if (isEmpty(this.kuromojiTokenizer)) {
      return new Promise(resolve => {
        Kuromoji.builder({
          dicPath: kuromojiDictPath
        }).build((err, tokenizer) => {
          this.set('kuromojiTokenizer', tokenizer);
          resolve();
        });
      });
    }
    return new Promise(resolve => resolve());
  }
  suggestFurigana(str) {
    let suggestion = '';
    if (!isEmpty(this.kuromojiTokenizer)) {
      const path = this.kuromojiTokenizer.tokenize(str);
      suggestion = path.map(token => token.reading || token.surface_form).join('');
    }
    return suggestion;
  }
}